import { LinkifiedText } from '@/components/LinkifiedText';
import type { TaskBlock } from '@/entities/chat-message';

interface InsightCardProps {
  block: TaskBlock;
}

export function InsightCard({ block }: InsightCardProps) {
  const { taskType, periodLabel } =
    block.data.period === 'week'
      ? { taskType: 'GOAL', periodLabel: 'THIS WEEK' }
      : { taskType: 'TASK', periodLabel: 'TODAY' };

  return (
    <div className="rounded-lg border border-gray-200 bg-white px-3 py-2.5">
      <div className="text-[11px] font-medium tracking-wide text-gray-400 uppercase">
        <span className="text-blue-500">NEW {taskType}</span> · {periodLabel}
      </div>
      <p className="mt-1 text-sm font-medium text-gray-900">
        <LinkifiedText text={block.data.title} />
      </p>
    </div>
  );
}
